import { costFormatter } from '../../format';

export const interpolations = (pet, cart, subscriptionProducts) => {
  const { name: pupName } = pet;
  const lineItem = cart.line_items.find(item => item.pet_id === pet.id);
  const product = subscriptionProducts.find(
    product => product.variants[0].sku === lineItem.subscription.sku,
  );

  return {
    frequency: product.weeks_of_food,
    numPacks: product.variants[0].tray_count,
    bagCount: product.variants[0].bag_count,
    pricePerWeek: costFormatter(product.variants[0].price_per_week),
    pupName,
  };
};
